import { Injectable } from '@angular/core';
import { createKpi, createKpis, KpiFilter, Kpis } from './kpi-model';
import { map } from 'rxjs/operators';
import { KpisTechnicienControllerApi } from '../../../api/services/kpis-technicien-controller-api';
import { GetKpisTechnicien$Params } from '../../../api/fn/kpis-technicien-controller/get-kpis-technicien';
import { KpisTechnicienResponseDto } from '../../../api/models/kpis-technicien-response-dto';

@Injectable({
  providedIn: 'root',
})
export class KpisTechnicienProvider {
  constructor(private kpiApi: KpisTechnicienControllerApi) {}

  async getKpis(technicienId: string, kpiFilter: KpiFilter): Promise<Kpis | null> {
    try {
      return await this.getKpisWithErrors(technicienId, kpiFilter);
    } catch (e) {
      console.log('an error occured');
      return Promise.resolve(null);
    }
  }

  async getKpisWithErrors(technicienId: string, kpiFilter: KpiFilter): Promise<Kpis | null> {
    const params: GetKpisTechnicien$Params = {
      id_technicien: technicienId,
      week: kpiFilter.semaine,
      year: kpiFilter.annee,
    };
    this.kpiApi.getKpisTechnicien(params);
    return await this.kpiApi
      .getKpisTechnicien(params)
      .pipe(
        map((result) => {
          return this.convertTo(result);
        })
      )
      .toPromise();
  }

  private convertTo(kpisHttpResponse: KpisTechnicienResponseDto): Kpis {
    if (kpisHttpResponse === null) {
      return null;
    }

    return createKpis(
      kpisHttpResponse.numeroSemaine,
      createKpi(
        kpisHttpResponse.saisieFilEau.pourcentage,
        kpisHttpResponse.saisieFilEau.tendance,
        kpisHttpResponse.saisieFilEau.realise,
        kpisHttpResponse.saisieFilEau.total
      ),
      createKpi(
        kpisHttpResponse.tauxOtPlanifiesRealises.pourcentage,
        kpisHttpResponse.tauxOtPlanifiesRealises.tendance,
        kpisHttpResponse.tauxOtPlanifiesRealises.realise,
        kpisHttpResponse.tauxOtPlanifiesRealises.total
      ),
      createKpi(
        kpisHttpResponse.tauxRemplissageAgenda.pourcentage,
        kpisHttpResponse.tauxRemplissageAgenda.tendance,
        kpisHttpResponse.tauxRemplissageAgenda.realise,
        kpisHttpResponse.tauxRemplissageAgenda.total
      )
    );
  }
}
